import { useGetTemplatesCount } from '@modusign/openapi-client-template';
import { useDispatch } from 'react-redux';

import useUsageCount from '@app/hooks/useUsageCount';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { setDataLayerVariables } from '@app/store/analytics/actions';

export default function useCreateTemplateAvailability() {
  const workspaceId = useWorkspaceId();
  const { templateCount } = useUsageCount();
  const dispatch = useDispatch();

  const { data: templates, isLoading } = useGetTemplatesCount(workspaceId, {
    query: {
      staleTime: 1000,
      refetchOnWindowFocus: false,
      enabled: !!workspaceId,
      onSuccess: (data) => {
        dispatch(
          setDataLayerVariables({
            event: 'countOfTemplatesUpdated',
            countOfTemplates: data.count,
          })
        );
      },
    },
  });

  return {
    isLoading,
    templateLimit: templateCount.limit,
    templateUsages: templates ? templates.count : Infinity,
    reachedTemplateLimit: !!(templates && templates.count === templateCount.limit),
    exceededTemplateLimit: !!(templates && templates.count > templateCount.limit),
    ableToCreateTemplate: !!(templates && templates.count < templateCount.limit),
  };
}
